import { t } from "../../../i18n";
import { CODE_PROFILES, type DesignCode, type RcDesignResult } from "@tasduvar/engine";
import { Section } from "./common";
export function References({ designCode = "tbdy2018", rc }: { designCode?: DesignCode; rc?: RcDesignResult }): JSX.Element {
  const code = CODE_PROFILES[designCode].references;
  return (
    <Section id="references" title={t("15. Kaynaklar")}>
      <ol>
        {code.map((r) => <li key={r}>{t(r)}</li>)}
        {rc ? rc.references.map((r) => <li key={r}>{t(r)}</li>) : null}
        {rc ? <li>{t("Arya, C., Design of Structures to BS 8110 (Örnek 3.16 konsol istinat duvarı — doğrulama); CE 437/537 Retaining Wall Design Example (ACI 318 — doğrulama).")}</li> : null}
        {designCode !== "tbdy2018" ? <li>{t("Türkiye Bina Deprem Yönetmeliği (TBDY 2018), Bölüm 16 — Temel Zemini ve Temeller için Özel Kurallar, §16.12 İstinat Yapıları. Resmî Gazete 18.03.2018/30364.")}</li> : null}
        <li>{t("TS 498 — Yapı Elemanlarının Boyutlandırılmasında Alınacak Yüklerin Hesap Değerleri.")}</li>
        {designCode !== "ec7" ? <li>{t("EN 1998-5:2004 Eurocode 8 — Bölüm 5: Temeller, istinat yapıları ve geoteknik konular.")}</li> : null}
        <li>{t("Das, B. M., Principles of Foundation Engineering (Coulomb ve Mononobe-Okabe toprak basıncı, Boussinesq sürşarj çözümleri).")}</li>
        <li>{t("Mononobe, N. & Matsuo, H. (1929); Okabe, S. (1926) — Statik-eşdeğer dinamik toprak basıncı.")}</li>
        <li>{t("Fine GEO5 — Gravity Wall Verification Manual (sanal arka düzlem yaklaşımı ile doğrulama).")}</li>
      </ol>
    </Section>
  );
}
